import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { TimeRange } from 'components/TimeRange/TimeRange';
import { CANCELLATION_FLYWHEEL } from 'constants/cancellation-types';
import { parseUnixSecondsDate } from 'helpers/time';
import { isEmpty } from 'helpers/verify';
import { messages } from '../CancelReservationModal.messages';
export var CancelReservationInquiry =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CancelReservationInquiry, _PureComponent);

  function CancelReservationInquiry() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CancelReservationInquiry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CancelReservationInquiry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasAcknowledgedLate: false
    });

    _this.handleLateAcknowledgment = _this.handleLateAcknowledgment.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CancelReservationInquiry, [{
    key: "canReserve",
    value: function canReserve() {
      return !this.props.late || this.state.hasAcknowledgedLate;
    }
  }, {
    key: "handleLateAcknowledgment",
    value: function handleLateAcknowledgment() {
      this.setState(function (state) {
        return {
          hasAcknowledgedLate: !state.hasAcknowledgedLate
        };
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
          reservationId = _this$props.reservationId,
          requestCancelReservation = _this$props.requestCancelReservation;

      if (this.canReserve()) {
        requestCancelReservation(reservationId);
      }
    }
  }, {
    key: "renderCredits",
    value: function renderCredits() {
      var credits = this.props.credits;

      if (!isEmpty(credits)) {
        return React.createElement("div", {
          className: "CancelReservationModal__inquiry__credits"
        }, React.createElement(FormattedHTMLMessage, _extends({}, messages.credits, {
          values: {
            creditsCount: credits
          }
        })));
      }
    }
  }, {
    key: "renderCreditRefundFooter",
    value: function renderCreditRefundFooter() {
      var credits = this.props.credits;

      if (credits > 0) {
        return React.createElement("p", {
          className: "CancelReservationModal__inquiry__credit-refund"
        }, React.createElement(FormattedHTMLMessage, _extends({}, messages.creditsRefund, {
          values: {
            creditsCount: credits
          }
        })));
      }
    }
  }, {
    key: "renderLateAcknowledgent",
    value: function renderLateAcknowledgent() {
      var _this$props2 = this.props,
          cancellationPolicy = _this$props2.cancellationPolicy,
          late = _this$props2.late;

      if (!late) {
        return;
      }

      var message = cancellationPolicy === CANCELLATION_FLYWHEEL ? messages.cancellationPolicyFlywheel : messages.cancellationPolicy;
      return React.createElement("div", {
        className: "modal__details-check"
      }, React.createElement("input", {
        className: "inline-block",
        id: "cancel-reservation-inquiry-acknowledgment",
        name: "understand",
        onChange: this.handleLateAcknowledgment,
        type: "checkbox"
      }), React.createElement("label", {
        htmlFor: "cancel-reservation-inquiry-acknowledgment",
        className: "inline-block"
      }, React.createElement(FormattedHTMLMessage, message)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          name = _this$props3.name,
          studio = _this$props3.studio,
          startTimestamp = _this$props3.startTimestamp,
          endTimestamp = _this$props3.endTimestamp,
          image = _this$props3.image;
      return React.createElement("section", null, React.createElement("div", {
        className: "modal__header modal__header__img pv++",
        style: {
          backgroundImage: "url(\"".concat(image, "\")")
        }
      }), React.createElement("div", {
        className: "modal__body text--center"
      }, React.createElement("div", {
        className: "mb"
      }, React.createElement("p", null, name), React.createElement("p", null, studio)), React.createElement("h3", {
        className: "text--xl"
      }, React.createElement(FormattedDate, {
        value: parseUnixSecondsDate(startTimestamp),
        weekday: "long",
        month: "long",
        day: "numeric"
      }), React.createElement("div", null, React.createElement(TimeRange, {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp
      }))), this.renderCredits()), this.renderLateAcknowledgent(), React.createElement("button", {
        className: "bt bt--danger bt--lg bt--width-lg mb-",
        disabled: !this.canReserve(),
        onClick: this.handleSubmit
      }, React.createElement(FormattedMessage, messages.cancelCta)), this.renderCreditRefundFooter());
    }
  }]);

  return CancelReservationInquiry;
}(PureComponent);
CancelReservationInquiry.propTypes = {
  cancellationPolicy: PropTypes.string.isRequired,
  credits: PropTypes.number,
  endTimestamp: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  late: PropTypes.bool,
  name: PropTypes.string.isRequired,
  requestCancelReservation: PropTypes.func.isRequired,
  reservationId: PropTypes.number.isRequired,
  startTimestamp: PropTypes.number.isRequired,
  studio: PropTypes.string.isRequired
};